// SyncFusionDateTimePicker.jsx
import React from "react";
import { DateTimePickerComponent, DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { useTheme } from "../../../contexts/ThemeContext";
import "./SyncFusionDateTimePicker.css";

const SyncFusionDateTimePicker = ({
  id,
  value,
  onChange,
  placeholder,
  min,
  max,
  width = "100%",
  step = 10,
  localUnderMaintenace
}) => {
  const isOnlyDate = id === "onlyDate";
  const { isLight } = useTheme();

  if (isOnlyDate) {
    return (
      <DatePickerComponent
        id={id}
        value={value}
        change={(e) => {
          if (e.value instanceof Date) {
            onChange(e.value);
          } else {
            onChange(null);
          }
        }}
        format="dd/MM/yyyy"
        locale="pt"
        placeholder={placeholder}
        min={min}
        max={max}
        width={width}
        strictMode={true}
        disabled={localUnderMaintenace == "S"}
        cssClass={isLight ? "light-theme-border" : ""}
      />
    );
  }

  return (
    <DateTimePickerComponent
      id={id}
      value={value}
      change={(e) => {
        if (e.value instanceof Date) {
          onChange(e.value);
        } else {
          onChange(null); // fallback
        }
      }}
      format="dd/MM/yyyy HH:mm"
      timeFormat="HH:mm"
      locale="pt"
      placeholder={placeholder}
      min={min}
      max={max}
      step={step}
      width={width}
      strictMode={true}
      disabled={localUnderMaintenace == "S"}
      cssClass={isLight ? "light-theme-border" : ""}
    />
  );
};

export default SyncFusionDateTimePicker;
